import styled from "styled-components"

import { media, Title } from "src/uikit"
import { Button } from "src/newUikit/Button/styled"

export const Container = styled.section`
  padding: 0 16px;

  .inner {
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${Title} {
    font-weight: 800;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    color: #0a1c61;
  }

  @media ${media.mobile} {
    ${Title} {
      font-size: 26px;
      line-height: 32px;
    }

    ${Button} {
      width: 100%;
    }
  }
`

export const List = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media ${media.mobile} {
    flex-direction: column;
  }
`

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 304px;
  margin: 20px 22px;

  :first-child,
  :nth-child(2) {
    flex-basis: 40%;
  }

  :first-child,
  :nth-child(3) {
    margin-left: 0;
  }

  :nth-child(2),
  :last-child {
    margin-right: 0;
  }

  svg {
    margin-bottom: 16px;
  }

  p {
    margin: 0;
  }

  span {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.8px;
    color: #1d2c7f;
    width: 304px;
  }

  @media ${media.tablet} {
    width: 213px;

    span {
      width: 213px;
    }
  }

  @media ${media.mobile} {
    margin: 0 !important;
    margin-bottom: 24px !important;
  }
`
